import { useNavigate, useParams } from "react-router-dom";
import { isLogin } from "../../../utils";
import { useEffect, useState } from "react";
import { getWellnessLectureDetailByWellnessLectureId } from "../../../service/wellnessLecture";
import { Button, Checkbox, Flex, Input, Modal, Rate, message } from "antd";
import ImageUploader from "../ui/ImageUploader";
import { createWellnessLectureReview } from "../../../service/wellnessLectureReview";
import { ReactComponent as CircleCheck } from "../../../assets/images/icon/circle-check.svg";
import { ReactComponent as Image } from "../../../assets/images/icon/img.svg";
import { ReactComponent as Star } from "../../../assets/images/icon/star.svg";
import dayjs from "dayjs";
import { TopBar } from "../../../widgets";
import { SolidBtn } from "../../../shared";
import { CheckCircleFilled, CheckCircleOutlined } from "@ant-design/icons";
import { isIOS } from "react-device-detect";

const { TextArea } = Input;

const CreateWellnessLectureReview = () => {
    const navigate = useNavigate();
    const { wellnessLectureId } = useParams();
    const [wellnessLecture, setWellnessLecture] = useState<IWellnessLectureDetailWebResponseV2>();
    const [uploadedUrls, setUploadedUrls] = useState<Array<string>>([]);
    const [content, setContent] = useState<string | undefined>(undefined);
    const [rating, setRating] = useState<number | undefined>(undefined);
    const [isPrivate, setIsPrivate] = useState<boolean>(false);
    const [cancelOpen, setCancelOpen] = useState<boolean>(false);

    useEffect(() => {
        if (!isLogin()) {
            navigate("/login")
            return;
        }
        if (!wellnessLectureId) return;

        getWellnessLectureDetailByWellnessLectureId(wellnessLectureId)
            .then(res => setWellnessLecture(res.data))
            .catch(err => console.error('err', err))

    }, [])


    const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (!wellnessLectureId) return;
        if (!rating) return message.error("별점을 입력해주세요.");

        const params = {
            rating: rating,
            content: content ?? '',
            wellnessLectureId: Number(wellnessLectureId),
            reviewCategoryList: [],
            imageUrlList: uploadedUrls,
            isPrivate: isPrivate
        }
        createWellnessLectureReview(params)
            .then(res => {
                if (res.data === true) {
                    navigate(-1);
                }
                else {
                    message.error('이미 리뷰를 작성했습니다.');
                }
            })
            .catch(err => console.error('err', err))
    }

    return <>
        <TopBar title="리뷰 작성" rightIcon={false} overOnClicks={{ left: (e) => { setCancelOpen(true) } }} position='fixed' thema='dark' />
        <div style={{ padding: 20 }}>
            {wellnessLecture && <>
                <div>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ width: 56, height: 56, display: 'inline-block' }}>
                            <img src={wellnessLecture.wellnessLectureImageUrl || `https://img.positivehotel.io/2024/12/17/LectureDetailDefault.webp`} alt="수업사진" width={'100%'} style={{ borderRadius: "999px", aspectRatio: 1, objectFit: 'cover' }} />
                        </div>
                        <div className="body/b1 secondary/s500" style={{ marginTop: 10 }}>{dayjs(wellnessLecture.wellnessLectureStartDateTime).format('YYYY.MM.DD (dd) HH:mm')} · {wellnessLecture.teacherName} 코치</div>
                        <div className="sub-title/st4" style={{ marginTop: 8, wordBreak: 'keep-all' }}>{wellnessLecture.wellnessLectureName}<br />어떠셨나요?</div>
                    </div>

                    <div style={{ marginTop: 16, textAlign: 'center' }}>
                        <div>
                            <Rate
                                style={{ fontSize: 48 }}
                                value={rating}
                                character={({ index = 0 }) => <Star width={48} height={48} fill={(rating ?? 0) <= index ? 'var(--secondarys200)' : "var(--primaryp600)"} />}
                                onChange={(value) => setRating(value)} />
                        </div>
                    </div>

                    <div style={{ marginTop: 32 }}>
                        <TextArea
                            className="custom-input-textarea"
                            onClear={() => { }}
                            showCount
                            maxLength={300}
                            onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setContent(e.target.value)}
                            placeholder="좋았던 경험, 혹은 아쉬웠던 점이 있다면 편하게 말씀해주세요."
                            value={content}
                            style={{ height: 148, resize: 'none' }}
                            styles={{ textarea: { padding: '8px 12px' } }}
                        />
                    </div>

                    <div style={{ marginTop: 32, marginInline: -20 }}>
                        <ImageUploader setUploadedUrls={setUploadedUrls} listType={'text'} styles={{ uploadSelect: { marginLeft: 20 } }} />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', marginTop: 20 }} onClick={() => setIsPrivate(curr => !curr)}>
                        {isPrivate
                            ? <CheckCircleFilled style={{ fontSize: '16px', color: 'var(--baseblack)' }} />
                            : <CheckCircleOutlined style={{ fontSize: '16px', color: 'var(--secondarys400)' }} />
                        }
                        <div className="body/b2 secondary/s800">코치 비공개로 작성하기</div>
                    </div>

                    <div style={{ marginTop: 24, marginBottom: isIOS ? 26 : 0 }}>
                        <Button className="sub-title/st3" type="primary" style={{ width: '100%', height: '50px', borderRadius: 4, border: 'none' }} onClick={handleClick}
                        >작성 하기</Button>
                    </div>
                </div>
            </>}
        </div>
        <Modal centered styles={{ content: { width: 'auto', marginInline: 12, padding: '20px 16px', borderRadius: 4 } }} open={cancelOpen} onCancel={() => setCancelOpen(false)} closeIcon={null} footer={null}>
            <div>
                <div style={{ textAlign: 'center' }}>
                    <div className="sub-title/st5 base/black" >
                        작성 취소
                    </div>
                    <div className="body/b2 secondary/s800" style={{ marginTop: 8 }}>
                        <div>
                            글을 저장하지 않고 나가시겠습니까?
                        </div>
                        <div>
                            작성한 글은 저장되지 않습니다.
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', gap: 16, justifyContent: 'center', marginTop: 16 }}>
                    <SolidBtn type='line' style={{ width: '100%', border: 'solid 1px var(--secondarys400)', color: 'var(--secondarys600)' }} icon={false} onClick={() => setCancelOpen(false)}>
                        돌아가기
                    </SolidBtn>
                    <SolidBtn type='solid' style={{ width: '100%' }} icon={false} onClick={() => { setCancelOpen(false); navigate(-1) }}>
                        작성 취소
                    </SolidBtn>
                </div>
            </div>
        </Modal>
    </>
}

export default CreateWellnessLectureReview;